<header class="header">
    @if (titleService.goBack() !== undefined) {
        <nav class="header__nav--left nav">
            <a
                class="btn--icon"
                [routerLink]="titleService.goBack()"
                (click)="titleService.goBack.set(undefined)"
                title="Terug"
            >
                <m-svg iconName="back" />
            </a>
        </nav>
    }

    <h1 class="header__title">
        {{ titleService.title }}
    </h1>

    @if (isConfigured || appService.config?.isConfigured) {
        <nav class="header__nav--right nav">
            @if (appService.coordinatorMode) {
                <!-- Spectate mode: back-to-teams + exit -->
                @if (appService.viewingPlannedEvent) {
                    <button
                        class="btn--icon"
                        (click)="backToTeamOverview()"
                        title="{{ 'coordinator.backToTeams' | translate }}"
                    >
                        <m-svg iconName="back" />
                    </button>
                }

                <button
                    class="btn--icon"
                    (click)="exitCoordinatorMode()"
                    title="{{ 'coordinator.exitCoordinatorMode' | translate }}"
                >
                    <m-svg iconName="arrow-left-from-bracket" />
                </button>
            } @else if (appService.inCoordinatorView) {
                <!-- Joined coordinator in coordinator view (team overview or viewing a team) -->
                @if (appService.viewingPlannedEvent) {
                    <button
                        class="btn--icon"
                        (click)="backToTeamOverviewFromJoined()"
                        title="{{ 'coordinator.backToTeams' | translate }}"
                    >
                        <m-svg iconName="back" />
                    </button>
                }

                <button
                    class="btn--white"
                    (click)="leaveTeamView()"
                    title="{{ 'coordinator.leaveView' | translate }}"
                >
                    <m-svg iconName="back" />
                    <span>{{ "coordinator.leaveView" | translate }}</span>
                </button>
            } @else {
                <!-- Normal mode -->
                @if (appService.isCoordinator && !appService.coordinatorMode && !appService.inCoordinatorView) {
                    <button
                        class="btn--icon"
                        (click)="enterCoordinatorView()"
                        title="{{ 'coordinator.viewTeams' | translate }}"
                    >
                        <m-svg iconName="eye-solid" />
                    </button>
                }

                <small class="px-8">v{{ guiVersion }}</small>

                <button
                    class="btn--white"
                    (click)="endWorkday()"
                    title="Beeindig werkdag"
                >
                    <span>{{ "header.endWorkday" | translate }}</span>
                    <m-svg iconName="stopwatch" />
                </button>

                <button
                    class="btn--icon"
                    (click)="userIconClick()"
                    title="{{ appService.selectedWorker?.firstName + ' ' + appService.selectedWorker?.lastName }}"
                >
                    <m-svg iconName="user" />
                </button>

                <div
                    class="notification"
                    [style]="{ '--color-notification': hasLatestVersion ? 'transparent' : 'red' }"
                >
                    <button
                        class="btn--icon"
                        #reloadButton
                        (click)="refreshClicked(reloadButton)"
                        title="Reload"
                    >
                        @if (hasLatestVersion) {
                            <m-svg iconName="reload" />
                        } @else {
                            <m-svg iconName="reload-exclamation" />
                        }
                    </button>
                </div>

                <app-refresh-popup #popupDialog />
            }
        </nav>
    }
</header>

@if ((appService.coordinatorMode || appService.inCoordinatorView) && (isConfigured || appService.config?.isConfigured)) {
    <div class="coordinator-banner">
        <m-svg
            iconName="stopwatch"
            style="--icon-width: 1.6rem; --icon-height: 1.6rem"
        />
        <span>{{ "coordinator.readonlyBanner" | translate }}</span>
    </div>
}
